export interface IntensityLevel {
  label: string;
  min: number;
  max: number;
  color: string;
  dotClass: string;
}

export const INTENSITY_LEVELS: IntensityLevel[] = [
  { label: 'Alta', min: 8, max: 10, color: '#ef4444', dotClass: 'bg-red-500' },
  { label: 'Media', min: 6, max: 7, color: '#f59e0b', dotClass: 'bg-amber-500' },
  { label: 'Baja', min: 4, max: 5, color: '#3b82f6', dotClass: 'bg-blue-500' },
  { label: 'Calma', min: 1, max: 3, color: '#64748b', dotClass: 'bg-slate-500' },
];

export function intensityLevel(intensity: number): IntensityLevel {
  return INTENSITY_LEVELS.find((l) => intensity >= l.min) ?? INTENSITY_LEVELS[INTENSITY_LEVELS.length - 1];
}

export interface RawActs {
  act1_scenes?: number[] | null;
  act2_scenes?: number[] | null;
  act3_scenes?: number[] | null;
}

export interface ScenesByAct {
  act1: number[];
  act2: number[];
  act3: number[];
}

export function scenesByAct(acts: RawActs | null | undefined, sceneNumbers?: number[] | null): ScenesByAct {
  const act1 = (acts?.act1_scenes ?? []).filter(Number.isFinite);
  const act2 = (acts?.act2_scenes ?? []).filter(Number.isFinite);
  const act3 = (acts?.act3_scenes ?? []).filter(Number.isFinite);
  const known = sceneNumbers && sceneNumbers.length > 0 ? sceneNumbers : [...act1, ...act2, ...act3];
  const numbers = [...new Set(known)].sort((a, b) => a - b);
  const out: ScenesByAct = { act1: [], act2: [], act3: [] };

  if (act1.length > 0 && act3.length > 0 && Math.max(...act1) < Math.min(...act3)) {
    const end1 = Math.max(...act1);
    const start3 = Math.min(...act3);
    for (const n of numbers) {
      if (n <= end1) out.act1.push(n);
      else if (n >= start3) out.act3.push(n);
      else out.act2.push(n);
    }
    return out;
  }

  const allowed = new Set(numbers);
  const seen = new Set<number>();
  const take = (list: number[], into: number[]) => {
    for (const n of [...new Set(list)].sort((a, b) => a - b)) {
      if (!allowed.has(n) || seen.has(n)) continue;
      seen.add(n);
      into.push(n);
    }
  };
  take(act1, out.act1);
  take(act2, out.act2);
  take(act3, out.act3);
  return out;
}
